import { render } from "./EditEmployeeLayout.vue?vue&type=template&id=af86f9aa&scoped=true"
import script from "./EditEmployeeLayout.vue?vue&type=script&lang=js"
export * from "./EditEmployeeLayout.vue?vue&type=script&lang=js"

import "./EditEmployeeLayout.vue?vue&type=style&index=0&id=af86f9aa&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\52618\\Documentos\\TheGoodMark\\Sistemas\\RHTGM\\orangehrm-5.9\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af86f9aa"]])

export default __exports__